import React, { useContext, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import { BsShareFill } from "react-icons/bs";
import { GrFormNextLink, GrFormPreviousLink } from 'react-icons/gr';
import { MdAlternateEmail } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from "react-router-dom";
import behance from '../images/icons/Behance.png';
import instagram from '../images/icons/Instagram.png';
import whatsapp from '../images/icons/Whatsapp.png';
import linkedin from '../images/icons/Linkedin.png';
import { BsPlusCircleDotted } from 'react-icons/bs';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { contextpass } from '../App';
import { SlClose } from 'react-icons/sl';
import { Link, useLocation } from 'react-router-dom';
// import { Link } from "react-router-dom";
import { decrement, increment, resetCount } from '../Redux/ReduxChild';

function FooterMain() {
	// const navto = useNavigate();
	const location = useLocation(); // use useLocation hook
	const isHomePage = location.pathname === '/'; // check if current path is home page
	const count = useSelector((state) => state.counter.value);
	const dispatch = useDispatch();
	const { social } = useContext(contextpass);
	const [show, setShow] = social;
	const target = useRef(null);
	useEffect(() => {
		dispatch(resetCount());
	}, [location, dispatch]);

	return (
		<React.Fragment>
			<Navbar className="footer" fixed="bottom">
				<Container fluid>
					<Nav className="me-auto nav-style align-items-center">
						{/* <motion.button
              initial={{ opacity: 0.6 }}
              whileHover={{
                scale: 1.2,
                transition: { duration: 1 },
              }}
              whileTap={{ scale: 0.9 }}
              whileInView={{ opacity: 1 }}
              className="btn text-white align-items-center border-0 "
              onClick={() => navto("/")}
            >
              <BsShareFill className="m-0 p-0 menu-icon" />
            </motion.button> */}
						<Nav.Link className="phone" href="https://www.instagram.com/" target="_blank">
							<img src={instagram} alt="instagram" className="social-icon" />
						</Nav.Link>
						<Nav.Link className="phone" href="https://www.behance.net/akmmubashir" target="_blank">
							<img src={behance} alt="behance" className="social-icon" />
						</Nav.Link>
						<Nav.Link className="phone" href="https://www.linkedin.com/in/akmmubashir" target="_blank">
							<img src={linkedin} alt="linkedin" className="social-icon" />
						</Nav.Link>
						<Nav.Link className="phone" href="https://api.whatsapp.com/send?phone=917593047634" target="_blank">
							<img src={whatsapp} alt="whatsapp" className="social-icon" />
						</Nav.Link>
						{/* <Nav.Link href="tel:+917593047634" className="text-white phone" >
              +91 75930 47634
            </Nav.Link> */}

						{/* mobile social start */}
						<Nav.Link className="text-white">
							<motion.button
								initial={{ opacity: 0.6 }}
								whileHover={{
									scale: 1.2,
									transition: { duration: 1 },
								}}
								whileTap={{ scale: 0.9 }}
								whileInView={{ opacity: 1 }}
								ref={target}
								onClick={() => setShow(!show)}
								className="btn text-white align-items-center border-0 phone-icon">
								{show ? <SlClose /> : <BsPlusCircleDotted />}
							</motion.button>
						</Nav.Link>
						<Overlay target={target.current} show={show} placement="right">
							{(props) => (
								<Tooltip id="overlay-example" className="tooltip-social" {...props}>
									<ul type="none" className="tooltip-icon1 p-0 m-0 d-inline-flex">
										<li>
											<Link className="" to="https://www.instagram.com/creative_with_akm/" target="_blank">
												<img src={instagram} alt="instagram" className="social-icon" />
											</Link>
										</li>
										<li>
											<Link className="" to="https://api.whatsapp.com/send?phone=917593047634" target="_blank">
												<img src={whatsapp} alt="whatsapp" className="social-icon" />
											</Link>
										</li>
									</ul>
								</Tooltip>
							)}
						</Overlay>
						<Overlay target={target.current} show={show} placement="top">
							{(props) => (
								<Tooltip id="overlay-example" className="tooltip-social" {...props}>
									<ul type="none" className="tooltip-icon2 p-0 m-0">
										<li>
											<Link className="" to="https://www.behance.net/akmmubashir" target="_blank">
												<img src={behance} alt="behance" className="social-icon" />
											</Link>
										</li>
										<li>
											<Link className="" to="https://www.linkedin.com/in/akmmubashir" target="_blank">
												<img src={linkedin} alt="linkedin" className="social-icon" />
											</Link>
										</li>
									</ul>
								</Tooltip>
							)}
						</Overlay>

						{/* <Nav.Link href="mailto:akmmubashir@gmail.com" className="text-white email">
							akmmubashir@gmail.com
						</Nav.Link>
						<Nav.Link href="mailto:akmmubashir@gmail.com" className="text-white">
							<motion.button
								initial={{ opacity: 0.6 }}
								whileHover={{
									scale: 1.2,
									transition: { duration: 1 },
								}}
								whileTap={{ scale: 0.9 }}
								whileInView={{ opacity: 1 }}
								className="btn text-white align-items-center border-0 email-icon">
								<MdAlternateEmail />
							</motion.button>
						</Nav.Link> */}
						{/* mobile social end */}

						{/* <Nav.Link href="tel:+917593047634" className="text-white">
              <motion.button
                initial={{ opacity: 0.6 }}
                whileHover={{
                  scale: 1.2,
                  transition: { duration: 1 },
                }}
                whileTap={{ scale: 0.9 }}
                whileInView={{ opacity: 1 }}
                className="btn text-white align-items-center border-0 phone-icon"
              >
                <MdAddIcCall />
              </motion.button>
            </Nav.Link> */}
					</Nav>
					{/* <Nav>
						<Nav.Link className="text-white fw-bolder pb-0">{count} / 6</Nav.Link>
					</Nav> */}
					{/* navigation screen start */}
					{isHomePage ? (
						<Nav className="ms-auto nav-style align-items-center">
							{count === 1 ? null : (
								<Nav.Link className="text-white pb-0 navigation-font" onClick={() => dispatch(decrement())}>
									<div className="d-flex justify-content-center align-items-center">
										{count !== 6 ? null : (
											<div className="bg-white rounded-circle me-2 d-flex justify-content-center align-items-center navigation-icon">
												<GrFormPreviousLink className="item" />
											</div>
										)}
										<span className="navigation-font">PREV</span>
									</div>
								</Nav.Link>
							)}
							{(count === 1) | (count === 6) ? null : <div className="fw-bolder navigation-font pb-0">|</div>}
							{count === 6 ? null : (
								<Nav.Link className="text-white pb-0 navigation-font" onClick={() => dispatch(increment())}>
									<div className="d-flex justify-content-center align-items-center">
										<span className="navigation-font">NEXT</span>
										{count !== 1 ? null : (
											<div className="bg-white rounded-circle ms-2 d-flex justify-content-center align-items-center navigation-icon">
												<GrFormNextLink className="item" />
											</div>
										)}
									</div>
								</Nav.Link>
							)}
						</Nav>
					) : (
						<Nav>
							<Nav.Link href="mailto:akmmubashir@gmail.com" className="text-white email">
								akmmubashir@gmail.com
							</Nav.Link>
							<Nav.Link href="mailto:akmmubashir@gmail.com" className="text-white">
								<motion.button
									initial={{ opacity: 0.6 }}
									whileHover={{
										scale: 1.2,
										transition: { duration: 1 },
									}}
									whileTap={{ scale: 0.9 }}
									whileInView={{ opacity: 1 }}
									className="btn text-white align-items-center border-0 email-icon">
									<MdAlternateEmail />
								</motion.button>
							</Nav.Link>
						</Nav>
					)}
					{/* navigation screen end */}
				</Container>
			</Navbar>
		</React.Fragment>
	);
}

export default FooterMain;
